import { render, staticRenderFns } from "./SupplierIoColumn.vue?vue&type=template&id=3d1e2d7c&"
import script from "./SupplierIoColumn.vue?vue&type=script&lang=js&"
export * from "./SupplierIoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports